import { render, staticRenderFns } from "./ManageUserPermission.vue?vue&type=template&id=bb025470"
import script from "./ManageUserPermission.vue?vue&type=script&lang=js"
export * from "./ManageUserPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports